import clsx from "clsx";

import { IMenuToggleProps } from "./";

const MenuToggle = ({
  className,
  hasItemSub = false,
  handleToggle,
  handleClick,
  tabIndex,
  children,
  ariaLabel,
}: IMenuToggleProps & { ariaLabel?: string }) => {
  return (
    <button
      type="button"
      className={clsx("menu-toggle", className && className)}
      onClick={hasItemSub ? handleToggle : handleClick}
      tabIndex={tabIndex ?? 0}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export { MenuToggle };
